module.exports = __webpack_public_path__ + "img/water-proof.ffe29328.jpg";